<template>
    <div class="sort-controls mr-2">
        <label class="sort-controls__label">Sort By:</label>
        <themed-select
            v-model="selectedSort"
            :options="sortOptions"
            @input="onSortChange"
            size="sm"
        />
        <themed-button
            variant="secondary"
            size="sm"
            @click="toggleDirection"
            :aria-label="direction === 'asc' ? 'Sort ascending' : 'Sort descending'"
        >
            <theme-icon 
                :icon="direction === 'asc' ? 'arrow-up' : 'arrow-down'" 
                type="icons" 
                classes="w-4 h-4"
            />
        </themed-button>
    </div>
</template>

<script>
import ThemeIcon from '../ThemeIcon.vue';
import ThemedSelect from '../ThemedSelect.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
    name: 'SortControls',

    components: {
        ThemeIcon,
        ThemedSelect,
        ThemedButton
    },

    props: {
        layout: {
            type: String,
            required: true,
            validator: value => ['site', 'projects'].includes(value)
        },
        sortBy: {
            type: String,
            required: true
        },
        sortDirection: {
            type: String,
            required: true,
            validator: value => ['asc', 'desc'].includes(value)
        }
    },

    data() {
        return {
            selectedSort: this.sortBy,
            direction: this.sortDirection
        };
    },

    computed: {
        sortOptions() {
            if (this.layout === 'site') {
                return [
                    { value: 'item.building.address_line_1', label: 'Address' },
                    { value: 'item.utilization', label: 'Utilization' },
                    { value: 'item.size', label: 'Size' }
                ];
            } else {
                return [
                    { value: 'item.address_line_1', label: 'Address' },
                    { value: 'item.pivot.score', label: 'Score' },
                    { value: 'item.total_square_footage', label: 'Size' }
                ];
            }
        }
    },

    watch: {
        sortBy(newValue) {
            this.selectedSort = newValue;
        },
        sortDirection(newValue) {
            this.direction = newValue;
        },
        layout() {
            // Reset to first option when layout changes
            this.selectedSort = this.sortOptions[0].value;
            this.onSortChange();
        }
    },

    methods: {
        onSortChange() {
            this.$emit('update:sortBy', this.selectedSort);
        },

        toggleDirection() {
            this.direction = this.direction === 'asc' ? 'desc' : 'asc';
            this.$emit('update:sortDirection', this.direction);
        }
    }
};
</script>
